import { IPortalPageProps } from '@/types/containers/portalPage';
import dynamic from 'next/dynamic';
import { basePageWrap } from '../BasePage';

import s from './PortalPage.module.css';

const DynamicEsriMap = dynamic(
    () => import('../../components/EsriMap/EsriMap'),
    {
        ssr: false,
    }
);

const PortalPage = ({
    portalId,
    host,
    is3d,
    minZoom,
    maxZoom,
    basemapgalleryWidget,
    layerWidget,
    legendWidget,
    locationWidget,
    scalebarWidget,
    searchWidget,
    zoomWidget,
    navigationtoggleWidget,
    childPois,
    siteSetting,
    reactionForm,
    showReactions,
    showReactionForm,
    keepReactionsVisible,
    id,
    automaticDisplay,
    reactionPanelTitle,
    reactionPanelContent,
    pageType,
    bookmarkMenubar,
    token,
    content,
}: IPortalPageProps) => {
    // map/rename the widgets to match the api-reference from arcgis.com
    // property 'expand' is for wigets that need to expand
    const widgets = [
        {
            name: 'BasemapGallery',
            visible: basemapgalleryWidget === 'off' ? false : true,
            position: basemapgalleryWidget,
            expand: true,
        },

        {
            name: 'LayerList',
            visible: layerWidget === 'off' ? false : true,
            position: layerWidget,
            expand: true,
            group: 'top-left',
        },
        {
            name: 'Legend',
            visible: legendWidget === 'off' ? false : true,
            position: legendWidget,
            expand: true,
            group: 'top-left',
        },
        {
            name: 'Locate',
            visible: locationWidget === 'off' ? false : true,
            position: locationWidget,
            expand: false,
        },
        {
            name: 'ScaleBar',
            visible: scalebarWidget === 'off' ? false : true,
            position: scalebarWidget,
            expand: false,
            unit: 'metric',
        },
        {
            name: 'Search',
            visible: searchWidget === 'off' ? false : true,
            position: searchWidget,
            expand: false,
        },
        {
            name: 'Zoom',
            visible: zoomWidget === 'off' ? false : true,
            position: zoomWidget,
            expand: false,
        },
        {
            name: 'NavigationToggle',
            visible: navigationtoggleWidget === 'off' ? false : true,
            position: navigationtoggleWidget,
            expand: false,
        },
    ];

    return (
        <div className={`PortalPage ` + s['portalpage']} key={id}>
            <DynamicEsriMap
                key={id}
                host={host}
                mapId={portalId}
                is3d={is3d}
                pois={childPois}
                widgets={widgets}
                center={undefined}
                zoom={undefined}
                minZoom={minZoom}
                maxZoom={maxZoom}
                respondForm={reactionForm}
                showReactions={showReactions}
                showReactionForm={showReactionForm}
                keepReactionsVisible={keepReactionsVisible}
                siteSetting={siteSetting}
                pageId={id}
                automaticDisplay={automaticDisplay}
                reactionPanelTitle={reactionPanelTitle}
                reactionPanelContent={reactionPanelContent}
                pageType={pageType}
                bookmarkMenubar={bookmarkMenubar}
                token={token}
                information={content}
            />
        </div>
    );
};

export default basePageWrap(PortalPage);
